<form #cacProfileDialog="ngForm" autocomplete="off">
  <mat-form-field class="fullWidth">
    <mat-label>Name</mat-label>
    <input matInput required [(ngModel)]="cacProfile.name" maxlength="255" name="name">
    <mat-error>
      Name is <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <div class="cac-radio-buttons">
    <mat-radio-group class="radio-option" [(ngModel)]="cacProfile.limitType"
                     [ngModelOptions]="{standalone: true}" (change)="onLimitTypeChange($event)">
      <div class="radio-options">
        <arm-form-title>Global Session Limit</arm-form-title>

        <mat-radio-button color="primary" [value]="'global'">
          <mat-form-field class="fullWidth">
            <mat-label>Total</mat-label>
            <input matInput [(ngModel)]="cacProfile.totalLimit" type="number" min="1"  name="totalLimit"
                   [required]="cacProfile.limitType === 'global'" [disabled]="cacProfile.limitType !== 'global'">
          </mat-form-field>
        </mat-radio-button>

        <arm-form-title>Session Limit by Direction</arm-form-title>

        <mat-radio-button color="primary" [value]="'limitByDirection'">
          <div class="direction-options">
            <mat-form-field class="fullWidth">
              <mat-label>Incoming</mat-label>
              <input matInput [(ngModel)]="cacProfile.incomingLimit" type="number" min="1"  name="incomingLimit"
                     [required]="cacProfile.limitType === 'limitByDirection' && !cacProfile.outgoingLimit"
                     [disabled]="cacProfile.limitType !== 'limitByDirection'">
            </mat-form-field>

            <mat-form-field class="fullWidth">
              <mat-label>Outgoing</mat-label>
              <input matInput [(ngModel)]="cacProfile.outgoingLimit" type="number" min="1"  name="outgoingLimit"
                     [required]="cacProfile.limitType === 'limitByDirection' && !cacProfile.incomingLimit"
                     [disabled]="cacProfile.limitType !== 'limitByDirection'">
            </mat-form-field>
          </div>
        </mat-radio-button>
      </div>
    </mat-radio-group>
  </div>
</form>
